import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './Home.css';
import WorkshopModal from './WorkshopModal';

export default function App() {
  const [locations, setLocations] = useState([]);
  const [filter, setFilter] = useState('wszystkie');
  const [filteredData, setFilteredData] = useState([]);
  const [activeWorkshop, setActiveWorkshop] = useState(null);

  useEffect(() => {
    fetch('/data/workshops.json')
      .then((res) => res.json())
      .then((data) => setLocations(data))
      .catch((err) => console.error('Błąd wczytywania danych:', err));
  }, []);

  useEffect(() => {
    let data = [...locations];

    switch (filter) {
      case 'rekodzielo':
      case 'sztuki-wizualne':
      case 'sztuki-wizualne-rekodzielo':
      case 'instytucje-kulturalne':
        data = data.filter((item) => item.category === filter);
        break;
      case 'accommodation':
        data = data.filter((item) => item.accommodation === true);
        break;
      case 'accessible':
        data = data.filter((item) => item.disabled === true);
        break;
      default:
        break;
    }

    setFilteredData(data);
  }, [filter, locations]);

  const customIcon = (url) =>
    L.icon({
      iconUrl: url,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });

  const groupIds = [1, 2, 3, 4, 5, 6, 7, 8];
  const wspolnaGrupa = filteredData.filter((item) =>
    groupIds.includes(item.id)
  );
  const pozostali =
    filter === 'instytucje-kulturalne'
      ? []
      : filteredData.filter(
          (item) => item.category !== 'instytucje-kulturalne'
        );

  const instytucjeKulturalne = filteredData.filter(
    (item) => item.category === 'instytucje-kulturalne'
  );

  return (
    <div
      className='container'
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/img/bg-zimowe.png)`,
      }}
    >
    
        <div className='poster-container-wystawa'>
            <a
        href='https://www.facebook.com/events/1323744585625080'
        target='_blank'
      >
          <img
            className='poster-desktop'
            src={`${process.env.PUBLIC_URL}/img/zimowe-targi-sztuki-i-rekodziela-w-memuaku-poziom.png`}
            alt='wystawa otwartych pracowni'
          />
          <img
            className='poster-mobile'
            src={`${process.env.PUBLIC_URL}/img/zimowe-targi-sztuki-i-rekodziela-w-memuaku-pion.png`}
            alt='wystawa otwartych pracowni'
          /></a>
        </div>
 

      <h2 className='subheadline'>11-13 lipca 2025</h2>
      <h1 className='headline'>
        Otwarte Pracownie <br />
        na Mazurach
      </h1>

      <div className='elements-section'>
        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-1.svg`}
          alt='dekoracyjne grafiki'
        />

        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-2.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-3.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-4.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-5.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float'
          src={`${process.env.PUBLIC_URL}/img/element-6.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float elements-desktop'
          src={`${process.env.PUBLIC_URL}/img/element-7.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float elements-desktop'
          src={`${process.env.PUBLIC_URL}/img/element-8.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element float elements-desktop'
          src={`${process.env.PUBLIC_URL}/img/element-9.svg`}
          alt='dekoracyjne grafiki'
        />
      </div>

      <div className='text-in-frame'>
        <p>
          <span className='bold-text'>
            Otwarte Pracownie na Mazurach to zaproszenie do zobaczenia Mazur
            z innej strony!
          </span>
        </p>
        <p>
          Bądź blisko przyrody, odwiedzaj twórców, rozmawiaj, poznawaj, zyskaj
          nową perspektywę.
        </p>
        <p>
          Dzięki poniższej mapie odkryjesz prywatne pracownie, domowe galerie,
          miejsca, w których odbywają się warsztaty twórcze – ceramiczne,
          malarskie, rzeźbiarskie, graficzne, tkackie i inne. Odwiedzając piękne
          miejsca, często skryte pośród łąk i jezior, spotkasz rękodzielników
          i artystów, którzy realizują swoje pasje, chętnie dzieląc się wiedzą
          i doświadczeniem.
        </p>
        <p>
          <span className='bold-text'>
            W dniach 11–13 lipca 2025 drzwi do tych miejsc otwierają się
            szeroko!
          </span>
        </p>
        <p>
          Pamiętaj, że wielu artystów chętnie przyjmie Cię w swojej pracowni
          także poza terminem naszego wydarzenia. Napisz, zadzwoń, zapytaj.
        </p>
      </div>

      <div className='elements-section second-elements'>
        <img
          className='element elements-mobile float'
          src={`${process.env.PUBLIC_URL}/img/element-7.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element elements-mobile float'
          src={`${process.env.PUBLIC_URL}/img/element-8.svg`}
          alt='dekoracyjne grafiki'
        />
        <img
          className='element elements-mobile float'
          src={`${process.env.PUBLIC_URL}/img/element-9.svg`}
          alt='dekoracyjne grafiki'
        />
      </div>

      <div className='map-container'>
        <div className='stripe'>
          <h2 className='subheadline-black'>
            3 dni – 40 pracowni <br /> artystycznych i rękodzielniczych!
          </h2>
        </div>

        <div className='legend'>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-artystyczne.svg`}
              alt='artystyczne'
              className='workshop-marker-mini'
            />
            <span>pracownie artystyczne</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-rekodzielnicze.svg`}
              alt='rekodzielnicze'
              className='workshop-marker-mini'
            />
            <span>pracownie rękodzielnicze</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-rekodzielniczo-artystyczne.svg`}
              alt='rekodzielniczo-artystyczne'
              className='workshop-marker-mini'
            />
            <span>pracownie rękodzielniczo-artystyczne</span>
          </div>
          <div className='legend-part'>
            <img
              src={`${process.env.PUBLIC_URL}/img/znaczniki/znacznik-instytucje-kulturalne-legend.svg`}
              alt='instytucje kulturalne'
              className='workshop-marker-mini'
            />
            <span>instytucje kulturalne</span>
          </div>
        </div>

        <MapContainer
          center={[54.03416228438315, 21.768465455440772]}
          zoom={9}
          className='map'
        >
          <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />

          {filteredData.some((item) => item.group) && (
            <Marker
              position={[54.03418, 21.768465]}
              icon={customIcon(
                process.env.PUBLIC_URL + '/img/znaczniki/znacznik-1-8.svg'
              )}
            >
              <Popup>
                <div className='popup-container group'>
                  <ul>
                    {filteredData
                      .filter((item) => item.group)
                      .map((item) => (
                        <a
                          key={item.id}
                          className='popup-link-group'
                          onClick={() => setActiveWorkshop(item)}
                        >
                          <li>
                            <img
                              src={`${process.env.PUBLIC_URL}/${item.marker}`}
                              className='marker-mini-group'
                            />
                            {item.name}
                          </li>
                        </a>
                      ))}
                  </ul>
                  <p>
                    ADRES: <br /> Szkoła Muzyczna w Giżycku <br /> ul. Kolejowa
                    22
                  </p>

                  <div className='popup-line'>
                    <img
                      src={`${process.env.PUBLIC_URL}/img/zegar.svg`}
                      alt='ikona zegara'
                      className='icon-small'
                    />
                    11:00 – 19:00
                  </div>
                </div>
              </Popup>
            </Marker>
          )}

          {filteredData
            .filter((item) => {
              if (item.group) return false; // pomijamy grupy, obsługiwane osobno

              const isInstitution = item.category === 'instytucje-kulturalne';
              const showInstitution =
                filter === 'wszystkie' || filter === 'instytucje-kulturalne';

              if (isInstitution && !showInstitution) return false;

              return true;
            })
            .map((item) => (
              <Marker
                key={item.id}
                position={item.position}
                icon={customIcon(process.env.PUBLIC_URL + '/' + item.marker)}
              >
                <Popup>
                  <div className='popup-container'>
                    {item.imageSmall && (
                      <img
                        src={`${process.env.PUBLIC_URL}/${item.imageSmall}`}
                        alt={item.name}
                        className='workshop-img-mini'
                      />
                    )}
                    <div className='popup-container-text'>
                      <b>{item.name}</b>
                      <p>
                        ADRES:
                        <br />
                        <span
                          dangerouslySetInnerHTML={{ __html: item.adress }}
                        />
                      </p>
                      {item.info &&
                        item.category === 'instytucje-kulturalne' && (
                          <p>
                            WYDARZENIA:
                            <br />
                            <span
                              className='popup-events-list'
                              dangerouslySetInnerHTML={{ __html: item.info }}
                            />
                          </p>
                        )}
                      {item.hours && (
                        <div className='popup-line'>
                          <img
                            src={`${process.env.PUBLIC_URL}/img/zegar.svg`}
                            alt='ikona zegara'
                            className='icon-small'
                          />
                          <span
                            dangerouslySetInnerHTML={{ __html: item.hours }}
                          />
                        </div>
                      )}
                      <div className='popup-line-icons'>
                        {item.disabled && (
                          <img
                            src={`${process.env.PUBLIC_URL}/img/niepelnosprawni.svg`}
                            alt='Udogodnienia dla niepełnosprawnych'
                            className='icon-small'
                          />
                        )}
                        {item.accommodation && (
                          <img
                            src={`${process.env.PUBLIC_URL}/img/nocleg.svg`}
                            alt='Nocleg'
                            className='icon-small-horizontal'
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {item.category !== 'instytucje-kulturalne' && (
                    <a
                      key={item.id}
                      className='popup-link'
                      onClick={() => setActiveWorkshop(item)}
                    >
                      Więcej informacji
                    </a>
                  )}
                </Popup>
              </Marker>
            ))}
        </MapContainer>
      </div>

      <div className='options-container'>
        <div className='option-filter-container'>
          <span className='options-text'>Pokaż:</span>
          <select
            onChange={(e) => setFilter(e.target.value)}
            className='options-filter'
          >
            <option value='wszystkie'>wszystkie miejsca</option>
            <option value='rekodzielo'>pracownie rękodzielnicze</option>
            <option value='sztuki-wizualne'>pracownie artystyczne</option>
            <option value='sztuki-wizualne-rekodzielo'>
              pracownie rękodzielniczo-artystyczne
            </option>
            <option value='instytucje-kulturalne'>instytucje kulturalne</option>
            <option value='accommodation'>miejsca oferujące nocleg</option>
            <option value='accessible'>
              miejsca dostosowane dla niepełnosprawnych
            </option>
          </select>
        </div>
      </div>

      <div className='workshops-container'>
        {pozostali.map((item) =>
          item.category !== 'instytucje-kulturalne' ? (
            <div
              key={item.id}
              className='workshop'
              onClick={() => setActiveWorkshop(item)}
            >
              <div className='workshop-img-wrapper'>
                <img
                  src={`${process.env.PUBLIC_URL}/${item.image}`}
                  alt={item.name}
                  className='workshop-img'
                />
                <div className='workshop-marker-wrapper'>
                  <img
                    src={`${process.env.PUBLIC_URL}/img/znaczniki/blank-under-marker.svg`}
                    alt='znacznik-tło'
                    className='workshop-marker-bg'
                  />
                  <img
                    src={`${process.env.PUBLIC_URL}/${item.marker}`}
                    alt='znacznik'
                    className='workshop-marker'
                  />
                </div>
              </div>

              <h6 className='text-specialization'>{item.specialization}</h6>
              <h3 className='text-name'>{item.name}</h3>
            </div>
          ) : null
        )}

        {activeWorkshop && (
          <WorkshopModal
            workshop={activeWorkshop}
            onClose={() => setActiveWorkshop(null)}
          />
        )}
      </div>

      <div className='text-in-frame events-exception'>
        <h2 className='subheadline-black exception-1'>Imprezy towarzyszące</h2>

        <span className='bold-text-bigger'>11-13.07</span>
        <p>
          <span className='bold-text'>
            Plener fotograficzny Młodzieżowej Rady Galerii Wozownia z Torunia
          </span>{' '}
          / Talki
        </p>
        <p>
          <a
            className='wave-underline'
            href='https://fb.me/e/5Oy9hlTHx'
            target='_blank'
          >
            <span className='bold-text'>Spektakle Teatru Delikates</span>
          </a>{' '}
          / Mącze 2a
        </p>
        <p>
          11.07 g. 18:00 – „Szeleszcząca trawa”
          <br />
          12.07 g. 18:00 – „Pozor už nemôžem”
          <br />
          13.07 g. 12:00 – 18:00 – „Z głową w chmurach. Marzyciele”
        </p>
        <p>
          <span className='bold-text'>Sitowie</span> / Choszczewo 57
        </p>
        <p>
          11.07 g. 18:00 –{' '}
          <a
            className='wave-underline'
            href='https://www.facebook.com/events/1242084757300775'
            target='_blank'
          >
            Wieczór muzyczno-graficzny
          </a>{' '}
          – koncert Moniki Mieczaniec, sitodruk na żywo
          <br />
          13.07 g. 12:00 –&nbsp;
          <a
            className='wave-underline'
            href='https://facebook.com/events/s/pe%C5%82na-kulturka-w-sitowiu/1796914067893648'
            target='_blank'
          >
            Pełna kulturka w Sitowiu
          </a>{' '}
          – spektakl, koncert i inne atrakcje dla dzieci
        </p>
        <span className='bold-text-bigger'>9.08</span>
        <p>
          <span className='bold-text'>
            Wystawa plenerowa Ogródek Sztuki w Muzeum Michała Kajki
          </span>{' '}
          / Ogródek 5
        </p>
        <span className='bold-text-bigger'>15-17.08</span>
        <p>
          <span className='bold-text'>Letnie targi sztuki i rękodzieła</span> /
          Memuak, Sztynort
        </p>
      </div>

      <img
        className='img-fundusz'
        src={`${process.env.PUBLIC_URL}/img/otwarte-pracownie-fundusz-celowy.png`}
        alt='Fundusz celowy'
      />

      <div className='logo-section'>
        <div className='logo-section-smaller'>
          <div className='logo-section-little'>
            <p>Organizator:</p>
            <img
              className='logo-section-img-horizontal'
              src={`${process.env.PUBLIC_URL}/img/logo/logo-nasze-talki.svg`}
              alt='Logo stowarzyszenia Nasze Talki'
            />
          </div>

          <div className='logo-section-little'>
            <p>Współfinansowanie:</p>
            <div className='logo-section-mini-container'>
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/gmina-wydminy.png`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img-horizontal-wide'
                src={`${process.env.PUBLIC_URL}/img/logo/wspolfinansowanie.svg`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/zaiks-logo.svg`}
                alt='Współfinansowanie'
              />
            </div>
          </div>

          <div className='logo-section-few'>
            <p>Partnerzy:</p>
            <div className='logo-section-mini-container'>
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-psm-gizycko.svg`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-galeria-ita-hareza.svg`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-memuak.png`}
                alt='Współfinansowanie'
              />
              <img
                className='logo-section-img'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-mk-ogrodek.png`}
                alt='Współfinansowanie'
              />
            </div>
          </div>

          <div className='logo-section-few'>
            <p>Patronat medialny:</p>
            <div className='logo-section-mini-container'>
              <img
                className='logo-section-img-horizontal-big'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-tvp-info.svg`}
                alt='Logo TVP Info'
              />

              <img
                className='logo-section-img-horizontal'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-made-in-warmia.svg`}
                alt='Logo'
              />

              <img
                className='logo-section-img-horizontal'
                src={`${process.env.PUBLIC_URL}/img/logo/logo-tvp3-olsztyn.svg`}
                alt='Logo'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
